import { apiURL } from './constants';
import axios from 'axios';

function authHeaders() {
  axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
}

/**
 * GET /api/pricing/rules/
 * Permission: pricing_rules_list
 * Filters include shipment_unit (unit id).
 */
export async function listPricingRules(params = {}) {
  authHeaders();
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') {
      searchParams.append(k, v);
    }
  });
  const q = searchParams.toString();
  const url = `${apiURL}/api/pricing/rules/${q ? `?${q}` : ''}`;
  return axios.get(url, { withCredentials: true });
}

/**
 * GET /api/pricing/rules/{id}/
 * Permission: pricing_rules_view
 */
export async function getPricingRule(id) {
  authHeaders();
  return axios.get(`${apiURL}/api/pricing/rules/${id}/`, { withCredentials: true });
}

/**
 * POST /api/pricing/rules/
 * Permission: pricing_rules_create
 */
export async function createPricingRule(data) {
  authHeaders();
  return axios.post(`${apiURL}/api/pricing/rules/`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * PUT /api/pricing/rules/{id}/
 * Permission: pricing_rules_update
 */
export async function updatePricingRule(id, data) {
  authHeaders();
  return axios.put(`${apiURL}/api/pricing/rules/${id}/`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * PATCH /api/pricing/rules/{id}/
 */
export async function patchPricingRule(id, data) {
  authHeaders();
  return axios.patch(`${apiURL}/api/pricing/rules/${id}/`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * POST /api/pricing/rules/{id}/duplicate/
 * Permission: pricing_rules_create
 * Body: { code (required), name?, active? }
 */
export async function duplicatePricingRule(id, data) {
  authHeaders();
  return axios.post(`${apiURL}/api/pricing/rules/${id}/duplicate/`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * DELETE /api/pricing/rules/{id}/ (soft-delete)
 * Permission: pricing_rules_delete
 */
export async function deletePricingRule(id) {
  authHeaders();
  return axios.delete(`${apiURL}/api/pricing/rules/${id}/`, { withCredentials: true });
}

/**
 * GET /api/pricing/rules/import/template/
 * Permission: pricing_rules_import
 */
export async function getPricingRulesImportTemplate() {
  authHeaders();
  return axios.get(`${apiURL}/api/pricing/rules/import/template/`, {
    responseType: 'blob',
    withCredentials: true,
  });
}

/**
 * GET /api/pricing/rules/import/sample/
 * Permission: pricing_rules_import
 */
export async function getPricingRulesImportSample() {
  authHeaders();
  return axios.get(`${apiURL}/api/pricing/rules/import/sample/`, {
    responseType: 'blob',
    withCredentials: true,
  });
}

/**
 * POST /api/pricing/rules/import/preview/
 * Permission: pricing_rules_import
 * Returns { preview, errors, row_errors }.
 */
export async function postPricingRulesImportPreview(file) {
  authHeaders();
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${apiURL}/api/pricing/rules/import/preview/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    withCredentials: true,
  });
}

/**
 * POST /api/pricing/rules/import/confirm/
 * Permission: pricing_rules_import
 * Body: { rules: [...] } (same shape as preview items).
 * Returns { detail, created_count, errors }.
 */
export async function postPricingRulesImportConfirm(rules) {
  authHeaders();
  return axios.post(
    `${apiURL}/api/pricing/rules/import/confirm/`,
    { rules },
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    }
  );
}
